<div id="change-reservation-period-mticket" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove uk-form-row">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Changer la période de la <br> réservation Mticket
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Date de début</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <div uk-grid class="remove-grid-ml-pl">
                                <div
                                    class="input alt color-cold-grey datepicker-bold uk-width-expand uk-display-inline-block">
                                    <app-datepicker [(date)]="dateStart"></app-datepicker>
                                </div>
                                <div class="uk-width-5-12 uk-position-relative">
                                    <span class="vertical-align uk-margin-left">à</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" min="0"
                                        max="59" [(ngModel)]="hourStart" type="number"
                                        style="padding: 4px; width: 50px;">
                                    <span class="vertical-align uk-margin-left">h</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" min="0"
                                        max="59" [(ngModel)]="minuteStart" type="number"
                                        style="padding: 4px; width: 50px;">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Date de fin</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <div uk-grid class="remove-grid-ml-pl">
                                <div
                                    class="input alt color-cold-grey datepicker-bold uk-width-expand uk-display-inline-block">
                                    <app-datepicker [(date)]="dateEnd"></app-datepicker>
                                </div>
                                <div class="uk-width-5-12 uk-position-relative">
                                    <span class="vertical-align uk-margin-left">à</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left"
                                        [(ngModel)]="hourEnd" min="0" max="59" type="number"
                                        style="padding: 4px; width: 50px;">
                                    <span class="vertical-align uk-margin-left">h</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left"
                                        [(ngModel)]="minuteEnd" min="0" max="59" type="number"
                                        style="padding: 4px; width: 50px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" *ngIf="loading === false"
                    (click)="updatePeriod()">Sauvegarder</button>
                <button class="button bold uk-margin-small-left" *ngIf="loading === true">
                    <div uk-spinner></div>
                </button>
            </p>
        </div>
    </div>
</div>